const _CSVToArray = (strData, strDelimiter) => {
    strDelimiter = (strDelimiter || ',');

    let objPattern = new RegExp(
        (
            // Delimiters.
            '(\\' + strDelimiter + '|\\r?\\n|\\r|^)' +

            // Quoted fields.
            '(?:"([^"]*(?:""[^"]*)*)"|' +

            // Standard fields.
            '([^"\\' + strDelimiter + '\\r\\n]*))'
        ),
        'gi'
    );

    let arrData = [[]];

    let arrMatches;

    while ((arrMatches = objPattern.exec(strData)) !== null) {
        let strMatchedDelimiter = arrMatches[1];

        if (
            strMatchedDelimiter.length &&
            (strMatchedDelimiter !== strDelimiter)
        ) {
            arrData.push([]);
        }

        if (arrMatches[2]) {
            const strMatchedValue = arrMatches[2].replace(
                new RegExp('""', 'g'),
                '"'
            );

            arrData[arrData.length - 1].push(strMatchedValue);
        } else {
            const strMatchedValue = arrMatches[3];
            arrData[arrData.length - 1].push(strMatchedValue);

        }
    }

    return (arrData);
};

const CSVParser = (input, delimiterType) => {
    const dataArray = _CSVToArray(input, delimiterType || '\t');
    return dataArray;
};

export default CSVParser;